import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-listprojects',
  templateUrl: './listprojects.component.html',
  styleUrls: ['./listprojects.component.scss']
})
export class ListprojectsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
